import * as cssDefs from 'consumer-page-widgets/AvatarCardLinkWidget/avatarCardLinkCssDefs';
import { Button, PlainButton, Typography } from 'omakase';
import { IconArrowRightSmall } from 'ui/icons';
import { IconChevronSmallRight } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { getAutoFormatSrcAndSrcSetForWidthPx } from '@tock/images';
import Anchor from 'components/Anchor';
import React from 'react';

export interface AvatarCardLinkProps {
  imageUrl: string;
  imageAlt: string;
  title: string;
  subtitle: string;
  linkText: string;
  linkHref: string;
  onClick?(): void;
}

const AvatarCardLink: React.FunctionComponent<AvatarCardLinkProps> = ({
  imageAlt,
  imageUrl,
  title,
  subtitle,
  linkText,
  linkHref,
  onClick,
}) => {
  const { src, srcSet } = getAutoFormatSrcAndSrcSetForWidthPx(
    {
      width: 120,
    },
    imageUrl
  );

  return (
    <div css={cssDefs.avatarCardLinkContainer}>
      <div css={cssDefs.avatarCardLinkImage}>
        <img alt={imageAlt} src={src} srcSet={srcSet} />
      </div>
      <Typography mb={2.5} variant="caption">
        {title}
      </Typography>
      <Typography css={cssDefs.subtitle} variant="body01">
        {subtitle}
      </Typography>
      <PlainButton
        component={Anchor}
        href={linkHref}
        size="large"
        variant="basic"
        iconEnd={
          <IconMigrationUtil
            legacyIcon={<IconArrowRightSmall />}
            newIcon={<IconChevronSmallRight />}
          />
        }
        css={cssDefs.desktopButton}
        onClick={onClick}
      >
        {linkText}
      </PlainButton>
      <Button
        component={Anchor}
        href={linkHref}
        size="medium"
        variant="basic"
        iconEnd={
          <IconMigrationUtil
            legacyIcon={<IconArrowRightSmall />}
            newIcon={<IconChevronSmallRight />}
          />
        }
        css={cssDefs.mobileButton}
        onClick={onClick}
      >
        {linkText}
      </Button>
    </div>
  );
};

export default AvatarCardLink;
